import { configureStore } from "@reduxjs/toolkit";
import reducers from "./Reducers";
import { getActivePage } from "../utils/getActivePage";
import { settingsApi } from "./settings/settingsApi";
import { dashboardApi } from "./dashboard/dashboardApi";
const activePage = getActivePage(window);
const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([dashboardApi.middleware, settingsApi.middleware]),

  preloadedState: {
    app: {
      activePage,
    },
    routerHistory: localStorage.getItem("routerHistory")
      ? JSON.parse(localStorage.getItem("routerHistory"))
      : [],
    companies: {
      companies: [],
      company: localStorage.getItem("company")
        ? JSON.parse(localStorage.getItem("company"))
        : {
          documents: [],
          history: [],
          info: {},
          selectedTab: "Info",
        },
    },
    transactions: {
      transactions: [],
      transaction: localStorage.getItem("transaction")
        ? JSON.parse(localStorage.getItem("transaction"))
        : {
          selectedTab: "Info",
          info: {},
          documents: [],
          history: [],
        },
    },
  },
  devTools: process && process.env.NODE_ENV !== "production",
});

store.subscribe(() => {
  const routerHistory = store.getState().routerHistory;

  routerHistory.length > 0 &&
    localStorage.setItem("routerHistory", JSON.stringify(routerHistory));

  const transaction = store.getState().transactions.transaction;
  const company = store.getState().companies.company;

  localStorage.setItem("transaction", JSON.stringify(transaction));
  localStorage.setItem("company", JSON.stringify(company));
});

export default store;
